// Admin Panel Cloud Settings - Implementare completă
import React, { useState } from 'react';
import {
  Cloud,
  Settings,
  Key,
  Shield,
  Globe,
  Server,
  Database,
  Lock,
  Unlock,
  Eye,
  EyeOff,
  CheckCircle2,
  AlertTriangle,
  RefreshCw,
  Save,
  TestTube,
  Zap,
  Activity,
  MapPin,
  HardDrive,
  Clock,
  Bell,
  Upload,
  Download,
  Link,
  Copy,
  Trash2,
  Plus,
  Edit
} from 'lucide-react';

const CloudSettings = () => {
  const [activeTab, setActiveTab] = useState('connection');
  const [showAccessKey, setShowAccessKey] = useState(false);
  const [showSecretKey, setShowSecretKey] = useState(false);
  const [isTestingConnection, setIsTestingConnection] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState('connected');

  // Mock settings data
  const [settings, setSettings] = useState({
    connection: {
      accessKeyId: 'AKIA3XAMPLE123456',
      secretAccessKey: 'wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY',
      region: 'eu-west-1',
      bucketName: 'botez-de-poveste-storage',
      endpoint: 'https://s3.eu-west-1.amazonaws.com',
      pathStyle: false,
      signatureVersion: 'v4'
    },
    security: {
      encryption: 'AES256',
      enableSSL: true,
      enableVersioning: true,
      enableMFA: false,
      publicReadAccess: false,
      corsEnabled: true,
      lifecycleEnabled: true
    },
    performance: {
      multipartUploadThreshold: 64,
      multipartChunkSize: 8,
      maxConcurrentUploads: 3,
      enableTransferAcceleration: false,
      enableCompression: true,
      cacheControl: 'max-age=31536000'
    },
    monitoring: {
      enableCloudWatch: true,
      enableAccessLogging: true,
      enableMetrics: true,
      retentionPeriod: 90,
      alertThreshold: 80,
      emailNotifications: true
    }
  });

  const [buckets] = useState([
    {
      name: 'botez-de-poveste-storage',
      region: 'eu-west-1',
      created: '2024-12-01',
      files: 1247,
      size: '45.7 GB',
      status: 'active',
      versioning: true,
      encryption: true
    },
    {
      name: 'botez-backups',
      region: 'eu-west-1',
      created: '2024-12-01',
      files: 89,
      size: '127.4 GB',
      status: 'active',
      versioning: true,
      encryption: true
    },
    {
      name: 'botez-temp-uploads',
      region: 'eu-west-1',
      created: '2024-12-15',
      files: 23,
      size: '2.3 GB',
      status: 'active',
      versioning: false,
      encryption: false
    }
  ]);

  const regions = [
    { value: 'us-east-1', label: 'US East (N. Virginia)' },
    { value: 'us-west-2', label: 'US West (Oregon)' },
    { value: 'eu-west-1', label: 'Europe (Ireland)' },
    { value: 'eu-central-1', label: 'Europe (Frankfurt)' },
    { value: 'ap-southeast-1', label: 'Asia Pacific (Singapore)' }
  ];

  const testConnection = async () => {
    setIsTestingConnection(true);
    
    // Simulate API test
    setTimeout(() => {
      setIsTestingConnection(false);
      setConnectionStatus('connected');
    }, 2000);
  };

  const saveSettings = () => {
    // Simulate save
    console.log('Settings saved:', settings);
  };

  const handleSettingChange = (category, key, value) => {
    setSettings(prev => ({
      ...prev,
      [category]: {
        ...prev[category],
        [key]: value
      }
    }));
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'connected':
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300">
            <CheckCircle2 className="w-3 h-3 mr-1" />
            Conectat
          </span>
        );
      case 'error':
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300">
            <AlertTriangle className="w-3 h-3 mr-1" />
            Eroare
          </span>
        );
      default:
        return (
          <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300">
            <Clock className="w-3 h-3 mr-1" />
            Necunoscut
          </span>
        );
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Settings className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
                  Setări Amazon S3
                </h1>
                <p className="text-gray-600 dark:text-gray-400 mt-1">
                  Configurează conexiunea și setările pentru Amazon S3
                </p>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              <button 
                onClick={testConnection}
                disabled={isTestingConnection}
                className="px-4 py-2 border border-blue-300 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20 font-medium rounded-lg transition-colors flex items-center"
              >
                {isTestingConnection ? (
                  <RefreshCw className="w-4 h-4 mr-2 animate-spin" />
                ) : (
                  <TestTube className="w-4 h-4 mr-2" />
                )}
                {isTestingConnection ? 'Se testează...' : 'Test Conexiune'}
              </button>
              <button 
                onClick={saveSettings}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center"
              >
                <Save className="w-4 h-4 mr-2" />
                Salvează Setări
              </button>
            </div>
          </div>
        </div>

        {/* Connection Status */}
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6 mb-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <Cloud className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                  Status Conexiune S3
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  Bucket: {settings.connection.bucketName} • Region: {settings.connection.region}
                </p>
              </div>
            </div>
            {getStatusBadge(connectionStatus)}
          </div>
        </div>

        {/* Tabs */}
        <div className="mb-8">
          <nav className="flex space-x-8">
            {[
              { id: 'connection', name: 'Conexiune', icon: Link },
              { id: 'security', name: 'Securitate', icon: Shield },
              { id: 'performance', name: 'Performanță', icon: Zap },
              { id: 'buckets', name: 'Bucket-uri', icon: Database },
              { id: 'monitoring', name: 'Monitorizare', icon: Activity }
            ].map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => setActiveTab(tab.id)}
                  className={`flex items-center px-3 py-2 rounded-lg font-medium transition-colors ${
                    activeTab === tab.id
                      ? 'bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300'
                      : 'text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
                  }`}
                >
                  <Icon className="w-4 h-4 mr-2" />
                  {tab.name}
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        {activeTab === 'connection' && (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
              Configurare Conexiune S3
            </h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Access Key ID
                </label>
                <div className="relative">
                  <input
                    type={showAccessKey ? 'text' : 'password'}
                    value={settings.connection.accessKeyId}
                    onChange={(e) => handleSettingChange('connection', 'accessKeyId', e.target.value)}
                    className="w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                  <button
                    type="button"
                    onClick={() => setShowAccessKey(!showAccessKey)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    {showAccessKey ? (
                      <EyeOff className="h-4 w-4 text-gray-400" />
                    ) : (
                      <Eye className="h-4 w-4 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Secret Access Key
                </label>
                <div className="relative">
                  <input
                    type={showSecretKey ? 'text' : 'password'}
                    value={settings.connection.secretAccessKey}
                    onChange={(e) => handleSettingChange('connection', 'secretAccessKey', e.target.value)}
                    className="w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                  />
                  <button
                    type="button"
                    onClick={() => setShowSecretKey(!showSecretKey)}
                    className="absolute inset-y-0 right-0 pr-3 flex items-center"
                  >
                    {showSecretKey ? (
                      <EyeOff className="h-4 w-4 text-gray-400" />
                    ) : (
                      <Eye className="h-4 w-4 text-gray-400" />
                    )}
                  </button>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Regiune
                </label>
                <select
                  value={settings.connection.region}
                  onChange={(e) => handleSettingChange('connection', 'region', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                  {regions.map((region) => (
                    <option key={region.value} value={region.value}>
                      {region.label}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Nume Bucket
                </label>
                <input
                  type="text"
                  value={settings.connection.bucketName}
                  onChange={(e) => handleSettingChange('connection', 'bucketName', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>

              <div className="lg:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Endpoint URL (opțional)
                </label>
                <input
                  type="url"
                  value={settings.connection.endpoint}
                  onChange={(e) => handleSettingChange('connection', 'endpoint', e.target.value)}
                  placeholder="https://s3.eu-west-1.amazonaws.com"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>
            </div>
          </div>
        )}

        {activeTab === 'security' && (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
              Setări Securitate
            </h3>
            
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Tip criptare
                </label>
                <select
                  value={settings.security.encryption}
                  onChange={(e) => handleSettingChange('security', 'encryption', e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                >
                  <option value="none">Fără criptare</option>
                  <option value="AES256">AES-256 (S3 Managed)</option>
                  <option value="aws:kms">AWS KMS</option>
                </select>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.security.enableSSL}
                      onChange={(e) => handleSettingChange('security', 'enableSSL', e.target.checked)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <span className="ml-2 text-sm text-gray-900 dark:text-white">
                      Activează SSL/TLS
                    </span>
                  </label>
                </div>

                <div>
                  <label className="flex items-center">
                    <input
                      type="checkbox"
                      checked={settings.security.enableVersioning}
                      onChange={(e) => handleSettingChange('security', 'enableVersioning', e.target.checked)}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                    />
                    <span className="ml-2 text-sm text-gray-900 dark:text-white">
                      Activează versioning
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'performance' && (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
              Setări Performanță
            </h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Pragul multipart upload (MB)
                </label>
                <input
                  type="number"
                  value={settings.performance.multipartUploadThreshold}
                  onChange={(e) => handleSettingChange('performance', 'multipartUploadThreshold', parseInt(e.target.value))}
                  min="1"
                  max="1000"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Upload-uri simultane maxime
                </label>
                <input
                  type="range"
                  min="1"
                  max="10"
                  value={settings.performance.maxConcurrentUploads}
                  onChange={(e) => handleSettingChange('performance', 'maxConcurrentUploads', parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>1</span>
                  <span className="font-medium">{settings.performance.maxConcurrentUploads}</span>
                  <span>10</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {activeTab === 'buckets' && (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                Bucket-uri S3
              </h3>
              <button className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors flex items-center">
                <Plus className="w-4 h-4 mr-2" />
                Nou Bucket
              </button>
            </div>

            <div className="space-y-4">
              {buckets.map((bucket, index) => (
                <div key={index} className="border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex items-center">
                      <Database className="w-6 h-6 text-blue-600 mr-3" />
                      <div>
                        <h4 className="font-semibold text-gray-900 dark:text-white">
                          {bucket.name}
                        </h4>
                        <p className="text-sm text-gray-500">
                          {bucket.region} • Creat: {bucket.created}
                        </p>
                      </div>
                    </div>
                    <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${
                      bucket.status === 'active' ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300' :
                      'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300'
                    }`}>
                      {bucket.status}
                    </span>
                  </div>

                  <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
                    <div>
                      <p className="text-gray-500 mb-1">Fișiere</p>
                      <p className="font-medium text-gray-900 dark:text-white">
                        {bucket.files.toLocaleString()}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500 mb-1">Dimensiune</p>
                      <p className="font-medium text-gray-900 dark:text-white">{bucket.size}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 mb-1">Versioning</p>
                      <p className="font-medium text-gray-900 dark:text-white">
                        {bucket.versioning ? (
                          <span className="text-green-600">Activ</span>
                        ) : (
                          <span className="text-gray-500">Inactiv</span>
                        )}
                      </p>
                    </div>
                    <div>
                      <p className="text-gray-500 mb-1">Criptare</p>
                      <p className="font-medium text-gray-900 dark:text-white">
                        {bucket.encryption ? (
                          <span className="text-green-600">Activă</span>
                        ) : (
                          <span className="text-gray-500">Inactivă</span>
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === 'monitoring' && (
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-soft border border-gray-200 dark:border-gray-700 p-6">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-6">
              Setări Monitorizare
            </h3>
            
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Perioada retenție log-uri (zile)
                </label>
                <input
                  type="number"
                  value={settings.monitoring.retentionPeriod}
                  onChange={(e) => handleSettingChange('monitoring', 'retentionPeriod', parseInt(e.target.value))}
                  min="1"
                  max="365"
                  className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Prag alertă utilizare (%)
                </label>
                <input
                  type="range"
                  min="50"
                  max="95"
                  value={settings.monitoring.alertThreshold}
                  onChange={(e) => handleSettingChange('monitoring', 'alertThreshold', parseInt(e.target.value))}
                  className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
                />
                <div className="flex justify-between text-xs text-gray-500 mt-1">
                  <span>50%</span>
                  <span className="font-medium">{settings.monitoring.alertThreshold}%</span>
                  <span>95%</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CloudSettings;